import React from 'react';
import { Flex, Text, Switch } from '@mantine/core';
import { FONT_WEIGHTS } from 'src/UI/theme/theme';

type Props = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export function PreserveAsIsToggle({ checked, onChange }: Props) {
  return (
    <Flex
      align="center"
      justify="space-between"
      p="sm"
      bg="gray.0"
      style={{ borderRadius: '8px', minWidth: 0 }}
    >
      <Text size="sm" fw={FONT_WEIGHTS.medium} c="gray.8" style={{ minWidth: 0 }} truncate>
        Preserve as-is
      </Text>
      <Switch checked={checked} onChange={event => onChange(event.currentTarget.checked)} />
    </Flex>
  );
}
